<template>
  <div id="p2p" class="main-tab-content">
    <div class="row">
      <h3>點對點搜尋</h3>
    </div>

    <!-- input fields -->
    <div class="row">

      <!-- start -->
      <div class="stop-search">
        <div>起點</div>
        <span>
                    <autocomplete
                      ref="startStop"
                      :debounce="800"
                      :onSelect="selectStartStop"
                      :onShouldGetData="getStops"
                      :onShouldRenderChild='printStops'
                      :url="autocompleteUrl"
                      anchor="stopc"
                      class="inline-form-control"
                      label="writer"
                      placeholder="Enter stop name here"
                    />
                    <img
                      class="img-target"
                      src="../../assets/target.png"
                      @click="getLocation('startStop')"
                    />
                </span>
      </div>

      <!-- end -->
      <div class="stop-search">
        <div>終點</div>
        <span>
                    <autocomplete
                      ref="endStop"
                      :debounce="800"
                      :onSelect="selectEndStop"
                      :onShouldGetData="getStops"
                      :onShouldRenderChild='printStops'
                      :url="autocompleteUrl"
                      anchor="stopc"
                      class="inline-form-control"
                      label="writer"
                      placeholder="Enter stop name here"
                    />
                    <img
                      class="img-target"
                      src="../../assets/target.png"
                      @click="getLocation('endStop')"
                    />
                </span>
      </div>

      <div>
        <Button
          @click="query"
        >搜尋
        </Button>

      </div>
    </div>

    <!-- display result -->
    <div class="row">
      <PointToPointResults></PointToPointResults>
    </div>

    <div class="row">
      <div style="clear: both; width: 100%;"></div>
    </div>
  </div>
</template>

<script>
import Autocomplete from 'vue2-autocomplete-js';
import {STOP_SUGGEST} from "../../config/paths/apiPaths";
import {mapActions, mapMutations, mapState} from 'vuex';
import PointToPointResults from "./PointToPointResults";
import locationPromise from "../../config/location/locationPromise";

export default {
  name: "PointToPoint",
  components: {
    Autocomplete, PointToPointResults,
  },
  data() {
    return {
      autocompleteUrl: STOP_SUGGEST,
      startc: '',
    };
  },
  computed: {
    ...mapState('p2p', ['startStop', 'endStop']),
    startStopc() {
      console.log(this.startStop);

      if (!this.startStop) {
        return '';
      }

      return this.startStop.stopc;
    },
    endStopc() {
      console.log(this.endStop);

      if (!this.endStop) {
        return '';
      }

      return this.endStop.stopc;
    },
  },

  methods: {
    ...mapMutations('p2p', ['setStop', 'setP2pResult']),
    ...mapActions('p2p', ['getP2p']),

    // todo: move to p2p actions
    getStops(stopName) {
      console.log(`GETTING STOPS: ${stopName}`);

      return fetch(`${STOP_SUGGEST}?q=${stopName}`)
        .then(response => response.json())
        .then(json => json.data);
    },
    selectStartStop(data) {
      this.setStop({
        field: 'startStop',
        stop: {
          ...data,
          type: 'stopid',
        },
      });
      return data.stopc;
    },
    selectEndStop(data) {
      this.setStop({
        field: 'endStop',
        stop: {
          ...data,
          type: 'stopid'
        },
      });
      return data.stopc;
    },
    printStops(data) {
      return `
                <a>
                    <span>${data.stopc}</span>
                </a>
                `;
    },

    // todo: move to p2p actions
    // p2p query:
    query() {
      this.getP2p({
        start: this.startStop,
        end: this.endStop,
      })
    },

    async getLocation(field) {
      const location = await locationPromise();

      console.log(location);

      this.setStop({
        field,
        stop: {
          ...location,
          type: 'latlng',
        },
      });

      this.$refs[field].setValue("Your Current Location");
    },

  },
}
</script>

<style scoped>
.stop-search {
  margin-bottom: 16px;
}

.img-target {
  width: 24px;
  height: 24px;
}

.inline-form-control {
  display: inline-block;
  width: 280px;
}

</style>
